module.exports = ".container1_ {\n  width: 100%;\n  margin: 0 auto;\n  padding: 20px;\n  background: #0F7B79; }\n\n.container1 {\n  padding-left: 10px; }\n"